import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Keyboard } from "./keyboard-CML2Vzkw.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
//#region src/scripts/extenders/collection-slider.js
var CollectionSlider = class extends HTMLElement {
	constructor() {
		super();
		this.swiper = null;
		this.visibilityObserver = null;
		this.idleCallback = null;
	}
	connectedCallback() {
		if (this.swiper) return;
		if (window.Shopify?.designMode || !("IntersectionObserver" in window)) {
			this.scheduleInitialization();
			return;
		}
		this.visibilityObserver = new IntersectionObserver((entries) => {
			if (!entries.some((entry) => entry.isIntersecting)) return;
			this.visibilityObserver.disconnect();
			this.scheduleInitialization();
		}, { rootMargin: "400px 0px" });
		this.visibilityObserver.observe(this);
	}
	initializeSwiper() {
		const swiperHolder = this.querySelector(".swiper");
		const previousButton = this.querySelector(".swiper-button-previous");
		const nextButton = this.querySelector(".swiper-button-next");
		if (!swiperHolder || this.swiper) return;
		this.swiper = new Swiper(swiperHolder, {
			modules: [
				Keyboard,
				Mousewheel,
				Navigation
			],
			direction: "horizontal",
			keyboard: { enabled: true },
			mousewheel: { forceToAxis: true },
			navigation: {
				prevEl: previousButton,
				nextEl: nextButton
			},
			slidesPerView: "auto",
			spaceBetween: 8,
			watchOverflow: true
		});
	}
	scheduleInitialization() {
		const initialize = () => {
			this.idleCallback = null;
			if (this.isConnected) this.initializeSwiper();
		};
		if ("requestIdleCallback" in window) this.idleCallback = window.requestIdleCallback(initialize, { timeout: 1e3 });
		else this.idleCallback = window.setTimeout(initialize, 0);
	}
	disconnectedCallback() {
		this.visibilityObserver?.disconnect();
		if (this.idleCallback !== null) {
			if ("cancelIdleCallback" in window) window.cancelIdleCallback(this.idleCallback);
			else window.clearTimeout(this.idleCallback);
			this.idleCallback = null;
		}
		this.swiper?.destroy(true, true);
		this.swiper = null;
	}
};
if (customElements.get("collection-slider") === void 0) customElements.define("collection-slider", CollectionSlider);
//#endregion
